module.exports = __webpack_public_path__ + "img/52114134_L.0a98997c.png";